import { Emitter } from "@noya-app/emitter";
import { MenuItem } from "@noya-app/noya-designsystem";
import { isDeepEqual } from "@noya-app/noya-utils";
import { Observable } from "@noya-app/observable";

export class MenuManager<T extends string = string> extends Emitter<[T]> {
  leftMenuItems$ = new Observable<MenuItem<T>[]>([], {
    isEqual: isDeepEqual,
  });
  rightMenuItems$ = new Observable<MenuItem<T>[]>([], {
    isEqual: isDeepEqual,
  });

  allMenuItems$ = Observable.combine(
    [this.leftMenuItems$, this.rightMenuItems$],
    ([left, right]) => [...left, ...right],
    { isEqual: isDeepEqual }
  );

  getLeftMenuItems(): MenuItem<T>[] {
    return this.leftMenuItems$.get();
  }

  getRightMenuItems(): MenuItem<T>[] {
    return this.rightMenuItems$.get();
  }

  getAllMenuItems(): MenuItem<T>[] {
    return this.allMenuItems$.get();
  }

  setLeftMenuItems(items: MenuItem<T>[]) {
    this.leftMenuItems$.set(items);
  }

  setRightMenuItems(items: MenuItem<T>[]) {
    this.rightMenuItems$.set(items);
  }

  showCommandPaletteEmitter = new Emitter<[boolean]>();
}
